// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b85d307f","488":"55da250c","732":"da813f76","977":"9e218ea8"}[chunkId] + ".chunk.js";
};